<nav class="site-navbar">
  <div class="navbar-inner">
    <a routerLink="/" class="navbar-logo">
      <img src="assets/logos/logo-master.png" alt="e-Likita Logo">
    </a>

    <!-- Desktop Menu -->
    <div class="navbar-links desktop-only">
      <ng-container *ngFor="let link of navLinks">
        <a *ngIf="link.path" [routerLink]="link.path" class="nav-link">
          {{ link.label }}
        </a>
        <a *ngIf="link.fragment" [href]="sectionHref(link.fragment)" class="nav-link">
          {{ link.label }}
        </a>
      </ng-container>
    </div>

    <!-- Auth Buttons (desktop) -->
    <div class="navbar-actions desktop-only">
      <button *ngIf="isAuthenticated" (click)="goToDashboard()" class="nav-btn nav-btn-primary">
        Proceed to Dashboard
      </button>
      <button *ngIf="!isAuthenticated" (click)="goToLogin()" [disabled]="loading" class="nav-btn nav-btn-secondary">
        {{ loading ? 'Signing in...' : 'Sign In' }}
      </button>
    </div>

    <!-- Mobile Toggle -->
    <button class="navbar-toggle mobile-only" (click)="toggleMenu()">
      <mat-icon>{{ isMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>

  <!-- Mobile Menu -->
  <div class="navbar-mobile-menu mobile-only" *ngIf="isMenuOpen">
    <ng-container *ngFor="let link of navLinks">
      <a *ngIf="link.path" [routerLink]="link.path" (click)="closeMenu()" class="mobile-link">
        {{ link.label }}
      </a>
      <a *ngIf="link.fragment" [href]="sectionHref(link.fragment)" (click)="closeMenu()" class="mobile-link">
        {{ link.label }}
      </a>
    </ng-container>

    <div class="mobile-actions">
      <button *ngIf="isAuthenticated" (click)="goToDashboard()" class="nav-btn nav-btn-primary">
        Proceed to Dashboard
      </button>
      <button *ngIf="!isAuthenticated" (click)="goToLogin()" [disabled]="loading" class="nav-btn nav-btn-secondary">
        {{ loading ? 'Signing in...' : 'Sign In' }}
      </button>
    </div>
  </div>
</nav>
